import { formatField } from './formatField';

interface DeltaInsertOp {
  insert: any;
  attributes: any;
}

interface IDataContext {
  [key: string]: string | number;
}

export class EChartsValue {
  deltaOp: DeltaInsertOp;
  fieldName?: string;

  /*
   * https://echarts.apache.org/en/option.html#series-line.markLine.label.formatter
   * E-Charts fields reference:
   * {a}: series name.
   * {b}: the name of a data item.
   * {c}: the value of a data item.
   * {d}: the percentage.
   */

  protected constructor(deltaOp: DeltaInsertOp) {
    this.deltaOp = deltaOp;
    this.fieldName = deltaOp.insert?.value?.fieldName;
  }

  static create = (deltaOp: DeltaInsertOp) => {
    return new EChartsValue(deltaOp);
  };
}
